import { RouterOutputs } from '@dreamstack/trpc/client'
import { useAnimation } from 'framer-motion'
import type { FunctionComponent } from 'react'
import React, { useEffect } from 'react'
import { MotionPanel } from './EntryWithSubNavbar'

const basePanelClass =
  'overflow-y-auto absolute flex justify-center inset-0 z-30 bg-accentroGray-full items-center mobile-motion-panel-scrollbar'

const scrollbarStyles = `
  .mobile-motion-panel-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .mobile-motion-panel-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`

export const MobileMotionPanel: FunctionComponent<
  React.PropsWithChildren<{
    entry: Pick<RouterOutputs['cms']['getNavEntries'][number], 'id'>
    open: boolean
    mobileNavOpen: boolean
    setFadedOut: React.Dispatch<React.SetStateAction<boolean>>
  }>
> = ({ entry, open, setFadedOut, mobileNavOpen, children }) => {
  const controls = useAnimation()
  useEffect(() => {
    const animate = async () => {
      if (!mobileNavOpen) return
      if (open) {
        setFadedOut(true)
        controls.start('displayedSub')
      } else {
        setFadedOut(false)
        await controls.start('fadeSubOut')
        await controls.start('hiddenSub')
      }
    }
    animate()
  }, [open, controls, setFadedOut, mobileNavOpen])
  return (
    <>
      <style>{scrollbarStyles}</style>
      <MotionPanel
        className={basePanelClass}
        unmount={false}
        static
        initial="hiddenSub"
        animate={controls}
        variants={{
          fadeSubOut: {
            display: 'flex',
            opacity: 0,
            translateX: '30px',
            transition: {
              duration: 0.15,
            },
          },
          hiddenSub: {
            display: 'none',
            transition: { duration: 0 },
          },
          displayedSub: {
            display: 'flex',
            translateX: 0,
            opacity: 1,
          },
        }}
        key={'panel_' + entry.id}
        transition={{ duration: 0.15 }}
      >
        {children}
      </MotionPanel>
    </>
  )
}
